import {
  faBuilding,
  faCheck,
  faClipboard,
  faClock,
  faClose,
  faEnvelope,
  faEye,
  faFileAlt,
  faFileInvoice,
  faFilePdf,
  faHome,
  faIdCard,
  faMapMarkerAlt,
  faMinus,
  faMobileAlt,
  faPen,
  faPhone,
  faPlus,
  faPrint,
  faSave,
  faSearch,
  faStore,
  faTrash,
  faUser,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, TextField } from "@mui/material";
import React, { Component } from "react";
import { StaticDialog } from "react-st-modal";
import { toast } from "react-toastify";
import InputMask from "react-input-mask";
import { apiUrl } from "../apiUrl";

class CadastrarCliente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      showModal: false,
      data: [],
      dados: {},
      dataClient: [],
      addEquipament: false,
      busca: "",
      rBusca: [],
      f: 2,
      BuscaM: "",
      rBuscaM: [],
      files: [],
      products: [],
      newProduct: false,
      equipaments: [],
      cpfCnpj: "",
      previews: [],
      tpcad: undefined,
      changeItens: {},
      openDropdownId: null,
      saved: undefined,
    };
  }
  componentDidMount() {
    console.log(this.props.dados);
    this.setState({ dados: this.props.dados || {} });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      dados: {
        ...prevState.dados,
        [name]: value,
      },
    }));
  };

  render() {
    return (
      <>
        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faUserPlus} />}
          onClick={() => this.setState({ newC: true })}
          disabled={this.props.asClient}
        >
          Cadastrar clientes
        </Button>
        <StaticDialog
          isOpen={this.state.newC}
          title="Cadastrar cliente"
          sx={{ zIndex: 9999 }}
          onAfterClose={(result) => {
            this.setState({
              newC: false,
              tpcad: null,
              files: [],
              previews: [],
              dados: {},
            });
          }}
        >
          {this.state.tpcad == null ? (
            <div
              style={{ display: "flex", justifyContent: "center", margin: 10 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 100,
                  height: 100,
                  cursor: "pointer",
                  border: "1px solid black",
                }}
                onClick={() => {
                  this.setState({ tpcad: "cpf" });
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <FontAwesomeIcon icon={faUser} />
                  Cadastro de Pessoa Física
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 100,
                  height: 100,
                  cursor: "pointer",
                  marginLeft: 10,
                  border: "1px solid black",
                }}
                onClick={() => {
                  this.setState({ tpcad: "cnpj" });
                }}
              >
                {" "}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <FontAwesomeIcon icon={faStore} />
                  Cadastro de Empresa
                </div>
              </div>
            </div>
          ) : (
            <>
              {this.state.tpcad == "cpf" ? (
                <>
                  <div className="container">
                    <form id="cadastroForm" onSubmit={(e) => e.preventDefault()}>
                      <div className="mt-3">
                        <div className="mb-2">
                          <label>Tipo de Cliente *</label>
                        </div>
                        <select
                          className="form-control"
                          name="type_c"
                          onChange={(event) => {
                            this.setState({
                              dados: {
                                ...this.state.dados,
                                type_c: event.target.value,
                              },
                            });
                          }}
                          value={this.state.dados.type_c || ""}
                        >
                          <option value="">Selecione</option>
                          <option value="locacao">Locação</option>
                          <option value="venda">Venda</option>
                          <option value="ambas">Ambas (Venda e Locação)</option>
                        </select>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <TextField
                            label="Nome Completo *"
                            name="nome"
                            value={this.state.dados.nome || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>

                        <div className="col-md-6">
                          <TextField
                            label="Data de Nascimento (Opcional)"
                            name="data_nascimento"
                            type="text"
                            value={this.state.dados.data_nascimento || ""}
                            onChange={this.handleChange}
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="cnpj_cpf"
                            value={this.state.dados.cnpj_cpf || ""}
                            onChange={this.handleChange}
                            mask="999.999.999-99"
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="CPF *"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: { height: 45, padding: "0 5px" },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <InputMask
                            name="rg"
                            value={this.state.dados.rg || ""}
                            onChange={this.handleChange}
                            mask="99.999.999-9"
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="RG (Opcional)"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: { height: 45, padding: "0 5px" },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <TextField
                            label="Nome do Pai (Opcional)"
                            name="npai"
                            value={this.state.dados.npai || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Nome da Mãe (Opcional)"
                            name="nmae"
                            value={this.state.dados.nmae || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <TextField
                            label="Telefone *"
                            name="telefone"
                            value={this.state.dados.telefone || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <InputMask
                            name="celular"
                            value={this.state.dados.celular || ""}
                            onChange={this.handleChange}
                            mask="(99) 9 9999-9999"
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="WhatsApp *"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: { height: 45, padding: "0 5px" },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>
                      <div>
                        <TextField
                          label="E-mail *"
                          name="email"
                          value={this.state.dados.email || ""}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          InputProps={{
                            style: { height: 45, padding: "0 5px" },
                          }}
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="cep"
                            value={this.state.dados.cep || ""}
                            onChange={async (e) => {
                              const cep = e.target.value.replace(/\D/g, "");
                              this.setState((prevState) => ({
                                dados: { ...prevState.dados, cep },
                              }));

                              if (cep.length === 8) {
                                fetch(`https://viacep.com.br/ws/${cep}/json/`)
                                  .then((response) => response.json())
                                  .then((data) => {
                                    if (data.erro) {
                                      toast.warning("CEP inválido");
                                    } else {
                                      this.setState((prevState) => ({
                                        dados: {
                                          ...prevState.dados,
                                          cep: data.cep,
                                          endereco: data.logradouro,
                                          bairro: data.bairro,
                                          cidade: data.localidade,
                                          estado: data.uf,
                                        },
                                      }));
                                    }
                                  })
                                  .catch(() => {
                                    toast.warning("CEP inválido");
                                  });
                              }
                            }}
                            mask="99.999-999"
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="CEP *"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: { height: 45, padding: "0 5px" },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Endereço *"
                            name="endereco"
                            value={this.state.dados.endereco || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <TextField
                            label="Número *"
                            name="numero"
                            value={this.state.dados.numero || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            label="Complemento"
                            name="complemento"
                            value={this.state.dados.complemento || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            label="Bairro *"
                            name="bairro"
                            onChange={this.handleChange}
                            value={this.state.dados.bairro || ""}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <TextField
                            label="Cidade *"
                            name="cidade"
                            value={this.state.dados.cidade || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Estado *"
                            name="estado"
                            value={this.state.dados.estado || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              ) : (
                <>
                  <div className="container">
                    <form id="cadastroForm" onSubmit={(e) => e.preventDefault()}>
                      <div className="mt-3">
                        <div className="mb-2">
                          <label>Tipo de Cliente *</label>
                        </div>
                        <select
                          className="form-control"
                          name="type_c"
                          onChange={(event) => {
                            this.setState({
                              dados: {
                                ...this.state.dados,
                                type_c: event.target.value,
                              },
                            });
                          }}
                          value={this.state.dados.type_c || ""}
                        >
                          <option value="">Selecione</option>
                          <option value="locacao">Locação</option>
                          <option value="venda">Venda</option>
                          <option value="ambas">Ambas (Venda e Locação)</option>
                        </select>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <TextField
                            label="Razão Social *"
                            name="nome"
                            value={this.state.dados.nome || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Nome Fantasia *"
                            name="nome_fantasia"
                            value={this.state.dados.nome_fantasia || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="cnpj_cpf"
                            value={this.state.dados.cnpj_cpf || ""}
                            onChange={this.handleChange}
                            mask="99.999.999/9999-99"
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="CNPJ *"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: { height: 45, padding: "0 5px" },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <InputMask
                            name="inscricao_estadual"
                            value={this.state.dados.inscricao_estadual || ""}
                            onChange={this.handleChange}
                            mask="999.999.999.999"
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="Inscrição Estadual *"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: { height: 45, padding: "0 5px" },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <TextField
                            label="Telefone *"
                            name="telefone"
                            value={this.state.dados.telefone || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <InputMask
                            name="celular"
                            value={this.state.dados.celular || ""}
                            onChange={this.handleChange}
                            mask="(99) 9 9999-9999"
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="WhatsApp *"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: { height: 45, padding: "0 5px" },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>
                      <div>
                        <TextField
                          label="E-mail *"
                          name="email"
                          value={this.state.dados.email || ""}
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          InputProps={{
                            style: { height: 45, padding: "0 5px" },
                          }}
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="cep"
                            value={this.state.dados.cep || ""}
                            onChange={async (e) => {
                              const cep = e.target.value.replace(/\D/g, "");
                              this.setState((prevState) => ({
                                dados: { ...prevState.dados, cep },
                              }));

                              if (cep.length === 8) {
                                fetch(`https://viacep.com.br/ws/${cep}/json/`)
                                  .then((response) => response.json())
                                  .then((data) => {
                                    if (data.erro) {
                                      toast.warning("CEP inválido");
                                    } else {
                                      this.setState((prevState) => ({
                                        dados: {
                                          ...prevState.dados,
                                          cep: data.cep,
                                          endereco: data.logradouro,
                                          bairro: data.bairro,
                                          cidade: data.localidade,
                                          estado: data.uf,
                                        },
                                      }));
                                    }
                                  })
                                  .catch(() => {
                                    toast.warning("CEP inválido");
                                  });
                              }
                            }}
                            mask="99.999-999"
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="CEP *"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: { height: 45, padding: "0 5px" },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Endereço *"
                            name="endereco"
                            value={this.state.dados.endereco || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <TextField
                            label="Número *"
                            name="numero"
                            value={this.state.dados.numero || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            label="Complemento"
                            name="complemento"
                            value={this.state.dados.complemento || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            label="Bairro *"
                            name="bairro"
                            onChange={this.handleChange}
                            value={this.state.dados.bairro || ""}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <TextField
                            label="Cidade *"
                            name="cidade"
                            value={this.state.dados.cidade || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Estado *"
                            name="estado"
                            value={this.state.dados.estado || ""}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: { height: 45, padding: "0 5px" },
                            }}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              )}
            </>
          )}
          {this.state.tpcad != null && (
            <>
              <div className="modal-fotter">
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    const dados = this.state.dados || {};

                    // Validação do Tipo de Cliente obrigatório
                    if (!dados.type_c) {
                      toast.warn("Selecione o Tipo de Cliente!");
                      return;
                    }

                    // Validações por Perfil (Física vs Jurídica)
                    if (this.state.tpcad === "cpf") {
                      if (!dados.nome) {
                        toast.warn("O campo Nome é obrigatório!");
                        return;
                      }
                      if (!dados.cnpj_cpf) {
                        toast.warn("O campo CPF é obrigatório!");
                        return;
                      }
                      if (!dados.telefone && !dados.celular) {
                        toast.warn("Informe ao menos um telefone ou WhatsApp!");
                        return;
                      }
                      if (!dados.email) {
                        toast.warn("O campo E-mail é obrigatório!");
                        return;
                      }
                      if (!dados.endereco || !dados.numero || !dados.bairro || !dados.cidade || !dados.estado || !dados.cep) {
                        toast.warn("Preencha todos os campos obrigatórios do endereço!");
                        return;
                      }
                    } else {
                      if (!dados.nome) {
                        toast.warn("O campo Razão Social é obrigatório!");
                        return;
                      }
                      if (!dados.nome_fantasia) {
                        toast.warn("O campo Nome Fantasia é obrigatório!");
                        return;
                      }
                      if (!dados.cnpj_cpf) {
                        toast.warn("O campo CNPJ é obrigatório!");
                        return;
                      }
                      if (!dados.inscricao_estadual) {
                        toast.warn("O campo Inscrição Estadual é obrigatório!");
                        return;
                      }
                      if (!dados.telefone && !dados.celular) {
                        toast.warn("Informe ao menos um telefone ou WhatsApp!");
                        return;
                      }
                      if (!dados.email) {
                        toast.warn("O campo E-mail é obrigatório!");
                        return;
                      }
                      if (!dados.endereco || !dados.numero || !dados.bairro || !dados.cidade || !dados.estado || !dados.cep) {
                        toast.warn("Preencha todos os campos obrigatórios do endereço!");
                        return;
                      }
                    }

                    const formData = new FormData();
                    formData.append("nome", dados.nome);
                    formData.append("type_c", dados.type_c);

                    if (this.state.tpcad == "cpf") {
                      formData.append("data_nascimento", dados.data_nascimento || "");
                      formData.append("rg", dados.rg || "");
                      formData.append("npai", dados.npai || "");
                      formData.append("nmae", dados.nmae || "");
                      formData.append("complemento", dados.complemento || "");
                    } else {
                      formData.append("nome_fantasia", dados.nome_fantasia || "");
                      formData.append("inscricao_estadual", dados.inscricao_estadual || "");
                      formData.append("complemento", dados.complemento || "");
                    }

                    formData.append("cnpj_cpf", dados.cnpj_cpf || "");
                    formData.append("email", dados.email || "");
                    formData.append("telefone", dados.telefone || "");
                    formData.append("celular", dados.celular || "");
                    formData.append("cep", dados.cep || "");
                    formData.append("endereco", dados.endereco || "");
                    formData.append("numero", dados.numero || "");
                    formData.append("bairro", dados.bairro || "");
                    formData.append("cidade", dados.cidade || "");
                    formData.append("estado", dados.estado || "");

                    this.state.files.forEach((file) => {
                      formData.append("images", file);
                    });

                    e.target.classList.add("load");
                    fetch(
                      `${apiUrl}/cadastrar-cliente${this.state.files.length > 0 ? "/files" : ""
                      }`,
                      {
                        method: "POST",
                        body: formData,
                      }
                    )
                      .then((response) => {
                        e.target.classList.remove("load");
                        if (response.status == 200) {
                          response.json().then((data) => {
                            this.props.response({
                              id: data.id,
                              nome: dados.nome,
                              cnpj_cpf: dados.cnpj_cpf,
                            });
                            this.setState({ newC: false });
                            toast.success("Cliente adicionado com sucesso!");
                          });
                        } else {
                          toast.error("Erro ao salvar o cliente no servidor.");
                        }
                      })
                      .catch(() => {
                        e.target.classList.remove("load");
                        toast.error("Falha na comunicação com o servidor!");
                      });
                  }}
                >
                  <FontAwesomeIcon icon={faSave} /> Salvar
                </button>
              </div>
            </>
          )}
        </StaticDialog>
      </>
    );
  }
}

export default CadastrarCliente;